import { useMutation, useQuery, useQueryClient } from 'react-query';
import { api } from '../constants';
import { AxiosInstance } from '../axios.config';
import { IStoreDetails } from './types';

const getStoreDetails = async (): Promise<IStoreDetails> => {
  const { data } = await AxiosInstance.get<IStoreDetails>(api.store.details);
  return data;
};

export const useStoreDetails = () => {
  return useQuery('storeDetails', getStoreDetails, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: 1,
  });
};

interface UpdateStoreResponse {
  message: string;
  data: IStoreDetails;
}

const postStoreDetails = async (formData: FormData): Promise<UpdateStoreResponse> => {
  const { data } = await AxiosInstance.patch<UpdateStoreResponse>(api.store.details, formData);
  return data;
};

export const usePostStoreDetails = () => {
  const queryClient = useQueryClient();
  return useMutation(postStoreDetails, {
    onSuccess: (response) => {
      queryClient.setQueryData('storeDetails', response.data);
    },
  });
};
